import WorkspaceSetupContainer from '../../atomic/molecules/WorkspaceSetupContainer';
import { ACCOUNT_SETUP_JOB } from '../../constants/endpoints';
import useOnBoardingWithoutOptionsController from './useOnBoardingWithoutOptionsController';
import useOnboardingJobSetup from '../../hooks/useOnboardingJobSetup';
import styled from 'styled-components';
import AssemblyLanderLoadingScreen from '../../atomic/molecules/AssemblyLanderLoadingScreen';

const StyledWrapper = styled.div`
  margin: 0 auto;
  max-width: 500px;
`;

const TriggerJobAndRenderSetupScreen = (props: any) => {
  const { preJobResponse, canSetManagerFilter } = props;
  useOnboardingJobSetup({
    apiName: ACCOUNT_SETUP_JOB,
    onboardingPath: '',
    preJobResponse: preJobResponse,
    canSetManagerFilter,
    pathName: '/home?showTemplate=true',
  });
  return (
    <StyledWrapper>
      <WorkspaceSetupContainer
        title="We’re setting up your workspace!"
        marginTop="48px"
      />
    </StyledWrapper>
  );
};

const OnBoardingWithoutOptionsController = () => {
  const { isSuccess, canSetManagerFilter, preJobResponse } =
    useOnBoardingWithoutOptionsController();

  return isSuccess && preJobResponse ? (
    <TriggerJobAndRenderSetupScreen
      preJobResponse={preJobResponse}
      canSetManagerFilter={canSetManagerFilter}
    />
  ) : (
    <AssemblyLanderLoadingScreen />
  );
};

export default OnBoardingWithoutOptionsController;
